import { SxProp, View } from 'dripsy';
import React, { useContext } from 'react';

import { ModalView } from '@/design-system/components/modal/ModalView';
import { UniNativeModal } from '@/design-system/components/modal/nativeModal/UniNativeModal';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';
import { UtxAppEmbed } from '@/design-system/components/utxAppEmbedCallback/utxAppEmbedCallback';
import { LayoutContext } from 'contexts/LayoutContext';
import { GetBrokersResponseItem } from '@utx/utx-client';
import { ConfirmExchangeScreen } from './ConfirmExchange.screen';
import { ExchangeConfirmForm } from './ExchangeConfirmForm.component';
import { ConfirmExchangeStackRoutes, ConfirmExchangeStackScreenProps } from './type';

export interface SubscribeAssetModalProps {
  data: GetBrokersResponseItem;
  shouldBeFetchFee: boolean;
  onResult: () => void;
}

export const ConfirmExchangeModal: React.FC<ConfirmExchangeStackScreenProps<ConfirmExchangeStackRoutes.ApplicationInstruction>> = ({
  navigation,
  route
}) => {
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    route.params.onResult();
    navigation.goBack();
  };
  if (layout.isMobile) {
    return (
      <View sx={stylesNative.containerNative}>
        <UniNativeModal onBack={onGoBack} showHeader={false}>
          <UtxAppEmbed route={route.name}>
            <ConfirmExchangeScreen onClose={onGoBack} data={route.params.data} shouldBeFetchFee={route.params.shouldBeFetchFee} />
          </UtxAppEmbed>
        </UniNativeModal>
      </View>
    );
  }

  const { useModalProps, closeModal } = useModalView({});
  return (
    <ModalView useModalProps={useModalProps} minWidth={500}>
      <ExchangeConfirmForm onClose={closeModal} data={route.params.data} shouldBeFetchFee={route.params.shouldBeFetchFee} />
    </ModalView>
  );
};

enum StyleName {
  container = 'container'
}

enum StyleNameNative {
  container = 'container',
  containerNative = 'containerNative',
  content = 'content'
}

const styles: Record<StyleName, SxProp> = {
  container: {}
};

const stylesNative: Record<StyleNameNative, SxProp> = {
  container: {
    flex: 1,
    height: '100%',
    backgroundColor: '$backgroundPrimary'
  },
  containerNative: {
    flex: 1,
    height: '100%',
    backgroundColor: 'transparent'
  },
  content: {
    flexGrow: 1,
    justifyContent: 'space-between'
  }
};
